import { render, staticRenderFns } from "./account_record_list.vue?vue&type=template&id=56b7429b&scoped=true"
import script from "./account_record_list.vue?vue&type=script&lang=js"
export * from "./account_record_list.vue?vue&type=script&lang=js"
import style0 from "./account_record_list.vue?vue&type=style&index=0&id=56b7429b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7429b",
  null
  
)

export default component.exports